import { render } from "./InstallCardModal.vue?vue&type=template&id=b8528048&scoped=true"
import script from "./InstallCardModal.vue?vue&type=script&lang=js"
export * from "./InstallCardModal.vue?vue&type=script&lang=js"

import "./InstallCardModal.vue?vue&type=style&index=0&id=b8528048&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8528048"]])

export default __exports__